import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import styles from './index.css';
import classNames from '../../../classnames/bind';
import { JOINED_STATUS } from '../../../constants';
import { dispatchPage } from '../../../utils/app';
import defaultImg from '../../img/defaultImg.png';

const cx = classNames.bind(styles);
const CircleInfoBtn = ({ joined, joinCircleHandle }) => {
    const joinHandle = e => {
        e.stopPropagation();

        // eslint-disable-next-line no-unused-expressions
        joinCircleHandle && joinCircleHandle();
    };
    // 已加入，不展示按钮

    if (joined === JOINED_STATUS.JOINED) {
        return null;
    }

    // 未加入，展示红色加入按钮
    if (!joined) {
        return (
            <span className={styles.join_circle_btn} onClick={joinHandle}>
                加入
            </span>
        );
    }

    // 本次刚加入，展示灰色按钮
    if (joined === JOINED_STATUS.JOINED_JUST_NOW) {
        return <span className={styles.joined_circle} />;
    }

    return null;
};

CircleInfoBtn.propTypes = {
    joined: PropTypes.number,
    joinCircleHandle: PropTypes.func,
};

const CircleInfoCard = ({ orgInfo, showLocation, joinCircleHandle, showJoinBtn = true, style }) => {
    const { title, descImage, joined, id } = orgInfo;

    const linkToCircle = () => {
        dispatchPage({
            url: `/ownerList?orgId=${id}`,
        });
    };

    return (
        <div className={cx('circle_card_container', { showLocation })} onClick={linkToCircle} style={{ ...style }}>
            <img src={descImage ?? defaultImg} className={styles.desc_image} />
            <div className={styles.circle_info}>
                <span className={styles.circle_title}>{title}</span>
                {showJoinBtn && <CircleInfoBtn joined={joined} joinCircleHandle={joinCircleHandle} />}
            </div>
        </div>
    );
};

CircleInfoCard.propTypes = {
    orgInfo: PropTypes.object,
    /**
     * 底部要展示定位，则需要设置margin-bottom
     */
    showLocation: PropTypes.bool,
    /**
     * 加入圈子回调
     */
    joinCircleHandle: PropTypes.func,
    showJoinBtn: PropTypes.bool,
    style: PropTypes.object,
};

export default errorBoundary(CircleInfoCard);
